import { IRoute } from "../../../common/helpers/routesMapper";
import { connect } from "react-redux";
import injectIntl from "../../../common/helpers/injectIntl";

import { seo } from "../../../common/helpers/seo";

import { IStateTree } from "../../store/interfaces";
import { IUser } from "../../store/user/models";
import { post } from "../../actions/general";

import lazyComponent from "./lazy";

const mapStateToProps = ({ user }: IStateTree) => ({
    user: user as IUser,
});

const mapDispatchToProps = { post };

export default {
    component: connect(mapStateToProps, mapDispatchToProps)(injectIntl(lazyComponent)),
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        return seo({ title: allMessage["contact.title"], allMessage, lang });
    },
} satisfies IRoute;
